import http from "../../http";

/**
 * 微信素材相关接口
 */
export default {
  // 获取素材列表
  list: (appid, params) => {
    return http.get("marketcenter/wxproxy/" + appid + "/material/list", params);
  },
};
